import { definePolicies } from '@libs/shared/frontend/helpers/define-policies.helper';
import { constant as rConstant } from 'remeda';

import { CustomerPermissionActionEnum, CustomerPermissionSubjectEnum, type components } from '@/libs/openapi/schema';
import { hasPermissions } from '@/utils/permissions.util';

interface PolicyContext {
  user: components['schemas']['MeResponseDto'];
}

export const auditLogPolicies = definePolicies((globalCtx: PolicyContext) => ({
  view: rConstant(hasPermissions(CustomerPermissionSubjectEnum.CUSTOMER_AUDIT_LOG, [
    CustomerPermissionActionEnum.READ,
    CustomerPermissionActionEnum.MANAGE,
  ])(globalCtx.user)),
}));
